/*! dependencies: cash, splide */

instant.ribbonSlider = {
  settings: cash.extend({

  }, instant.settings && instant.settings.ribbonSlider ? instant.settings.ribbonSlider : {}),
  init: function () {
    var ribbonSliders = cash('.js-ribbonSlider .js-splide');

    for (var i = 0; i < ribbonSliders.length; i++) {
      new Splide(ribbonSliders[i], {
        type: 'loop',
        perPage: 1,
        focus: 'center',
        padding: '25vw',
        breakpoints: {
          1023: {
            padding: '0'
          }
        }
      }).mount();
    }
  }
}